module.exports = __webpack_public_path__ + "assets/img/1dfb6579b5ac646f6656ba6daa3d3a0e.png";